import React from 'react';
import PropTypes from 'prop-types';

import { buildLinksMap, EXPAND_ARROW, COLLAPSE_ARROW } from '../../../utils/trackingLinks';
import Network from './Network';
import MobileIcon from '../../../resources/png/icon_mobile.png';

const App = ({
    app = {},
    css = {},
    editingCampaign = '',
    editCampaignName = () => {},
    editClicked = () => {},
    enabledCampaignEditing = false,
    expanded = false,
    expandedCampaigns = [],
    expandedNetworks = [],
    deleteClicked = () => {},
    toggleExpandApp = () => {},
    toggleExpandNetwork = () => {},
    toggleExpandCampaign = () => {},
}) => {
    // get app icon from the first app site
    const appIconUrl = app.sites[0].icon || undefined;
    const useDefaultIcon =
        !appIconUrl ||
        appIconUrl === '' ||
        appIconUrl === 'https://cdn.singular.net/dashboard/icon/1dbacc8dc07551adf8fffa21d4dee93a79f37105' ||
        appIconUrl === 'https://cdn.singular.net/dashboard/icon/396fc6e74cac1190d4725ed29f6224274bd7cd3e';

    const linksMap = buildLinksMap(app);
    const networksCount = Object.keys(linksMap.networks).length;
    const campaignsCount = Array.from(new Set(app.links.map(link => link.campaign_name))).length;

    if (networksCount === 0) {
        return <span />;
    }
    return (
        <div className={css.AppWrapper}>
            <div className={css.AppHeading} onClick={toggleExpandApp}>
                {useDefaultIcon ? (
                    <div className={css.AppIcon} style={{ backgroundColor: '#CCCCCC' }}>
                        <img
                            className={css.AppIcon}
                            src={MobileIcon}
                            style={{ width: '30px', height: '48px', marginTop: '6px' }}
                            alt={app.name}
                        />
                    </div>
                ) : (
                    <div className={css.AppIcon}>
                        <img className={css.AppIcon} src={appIconUrl} alt={app.name} />
                    </div>
                )}
                <div className={css.AppCollapseIcon}>{expanded ? COLLAPSE_ARROW : EXPAND_ARROW}</div>
                <div className={css.AppHeadingText}>
                    <div className={css.AppName}>{app.name}</div>
                    <div className={css.AppDetails}>
                        {`${networksCount} Ad Network${networksCount !== 1 ? 's' : ''}, ${campaignsCount} Campaign${
                            campaignsCount !== 1 ? 's' : ''
                        }`}
                    </div>
                </div>
            </div>
            {expanded && (
                <div className={css.AppBody}>
                    {Object.keys(linksMap.networks)
                        .sort()
                        .map(network => {
                            return (
                                <Network
                                    css={css}
                                    network={network}
                                    linkType={linksMap.networks[network].type}
                                    campaigns={linksMap.networks[network].campaigns}
                                    expanded={expandedNetworks.indexOf(network) > -1}
                                    expandedCampaigns={expandedCampaigns}
                                    app_id={app.id}
                                    key={`app_${app.id}_network_${network}`}
                                    toggleExpand={toggleExpandNetwork}
                                    toggleExpandCampaign={toggleExpandCampaign}
                                    deleteClicked={deleteClicked}
                                    editCampaignName={editCampaignName}
                                    editClicked={editClicked}
                                    editingCampaign={editingCampaign}
                                    enabledCampaignEditing={enabledCampaignEditing}
                                />
                            );
                        })}
                </div>
            )}
        </div>
    );
};

App.propTypes = {
    app: PropTypes.objectOf(PropTypes.any),
    css: PropTypes.objectOf(PropTypes.any),
    deleteClicked: PropTypes.func,
    editCampaignName: PropTypes.func,
    editClicked: PropTypes.func,
    editingCampaign: PropTypes.string,
    enabledCampaignEditing: PropTypes.bool,
    expanded: PropTypes.bool,
    expandedCampaigns: PropTypes.arrayOf(PropTypes.any),
    expandedNetworks: PropTypes.arrayOf(PropTypes.any),
    toggleExpandApp: PropTypes.func,
    toggleExpandCampaign: PropTypes.func,
    toggleExpandNetwork: PropTypes.func,
};

export default App;
